import { Component, OnInit, ViewChild, Injectable } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import * as moment from 'moment';
import Swal from 'sweetalert2';
import { NgxSpinnerService } from "ngx-spinner";
import { FormGroup, FormControl, Validators, FormBuilder } from '@angular/forms';
// import { NgbDateStruct, NgbCalendar, NgbDatepicker, NgbDate, NgbDatepickerConfig, NgbDateParserFormatter } from '@ng-bootstrap/ng-bootstrap';
// import {NgbCalendar, NgbDate, NgbDateStruct, NgbDatepicker, NgbInputDatepickerConfig} from '@ng-bootstrap/ng-bootstrap';

import {NgbCalendar, NgbDateAdapter, NgbDatepicker,NgbDate, NgbDateParserFormatter, NgbDateStruct, NgbDatepickerConfig} from '@ng-bootstrap/ng-bootstrap';
import { ApiRequestService } from '../api-request.service';
@Injectable()
export class CustomAdapter extends NgbDateParserFormatter {
  readonly DT_FORMAT = 'MM/DD/YYYY';

  parse(value: string): NgbDateStruct | null {
      if (value) {
          value = value.trim();
          let mdt = moment(value, this.DT_FORMAT)
      }
      return null;
  }
  format(date: NgbDateStruct): string {
      if (!date) return '';
      let mdt = moment([date.year, date.month - 1, date.day]);
      if (!mdt.isValid()) return '';
      return mdt.format(this.DT_FORMAT);
  }
}

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css'],
  // providers: [NgbDatepickerConfig]
  providers: [
    {provide: NgbDateParserFormatter, useClass: CustomAdapter},
  ]
})
export class HomeComponent implements OnInit {
	model: NgbDateStruct | any;
  // date: { month: number, day:number, year: number };
	// maxDate : any;
  minDate : any = {};
  expComMinDate : any = {};
  @ViewChild('dp') dp: NgbDatepicker | any;
  layersData: any;
  customData: any = {};
  personalRep: any = {};
  filesList: any = [];
  linesR: any = [];
  lines: any = [];
  fileName: any;
  // personalForm: FormGroup;

  generalRep: any = {};
  generalForm: FormGroup;
  checkAll:any;
  siteKey:string ="6Le2soMhAAAAAOt3K09ggDnBsoQ4MeKt_DFYorgm";
  new_accessToken: any;
  constructor(
  	public ngb : NgbModule,
    // public formsModule :FormsModule,
    private calendar: NgbCalendar,
    private config: NgbDatepickerConfig,
    private formBuilder: FormBuilder,
    public restAPI:ApiRequestService,
    private activatedRoute: ActivatedRoute,
    private spinner: NgxSpinnerService,
    // private config: NgbInputDatepickerConfig
    ) { 
  	this.calendar.getToday();
    
    const current = new Date();
    config.minDate = { year: current.getFullYear(), month: current.getMonth() + 1, day: current.getDate() };
    config.outsideDays = 'hidden';

    // config.minDate = {year: 1900, month: 1, day: 1};
    config.maxDate = {year: 2099, month: 12, day: 31};
    // this.generalRep.expectedStartDate: NgbDateStruct | any = this.calendar.getToday();
    this.generalRep.thicknessOfTheBoard = '5';

    // days that don't belong to current month are not visible
    // config.outsideDays = 'hidden';

    // weekends are disabled
    // config.markDisabled = (date: NgbDate) => calendar.getWeekday(date) >= 6;

    // setting datepicker popup to close only on click outside
    // config.autoClose = 'outside';

    this.minDate = {
      year: current.getFullYear(),
      month: current.getMonth() + 1,
      day: current.getDate()
    };
    // this.personalForm = new FormGroup({
    //   companyName:new FormControl('', [Validators.required, Validators.minLength(3), Validators.maxLength(100)]),
    //   firstName: new FormControl('', [Validators.required, Validators.minLength(3), Validators.maxLength(100), Validators.pattern('^[a-zA-Z]+$')]),
    //   lastName: new FormControl('', [Validators.required, Validators.minLength(3), Validators.maxLength(100), Validators.pattern('^[a-zA-Z]+$')]),
    //   email: new FormControl('', [Validators.required, Validators.email, Validators.minLength(4), Validators.pattern('^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$')]),
    //   phoneNumber: new FormControl('', [Validators.required, Validators.minLength(10), Validators.maxLength(10)])
    // });

    this.generalForm = new FormGroup({
      designITAR: new FormControl('', [Validators.required]),
      expectedStartDate: new FormControl('', [Validators.required]),
      expectedComplitionDate: new FormControl('', [Validators.required]),
      scopeOfDesign: new FormControl('', [Validators.required]),
      scopeOfDesign_otherNotes: new FormControl('', [Validators.required, Validators.maxLength(250)]),
      isStatementOfWorkSOW : new FormControl('', [Validators.required]),
      billOfMaterialType : new FormControl('', [Validators.required]),
      isTheSchematicAvailableForTheDesign : new FormControl('', [Validators.required]),
      formatOfTheSchematicDesign : new FormControl('', [Validators.required]),
      isABlockDiagramOfTheDesignAvailable : new FormControl('', [Validators.required]),
      developSchematicFromBlockDiagram : new FormControl('', [Validators.required]),
      describeYourBoard : new FormControl('', [Validators.required]),
      describeYourBoard_otherNotes : new FormControl('', [Validators.required, Validators.maxLength(250)]),
      circuitHaveHighFrequencySignals : new FormControl('', [Validators.required]),
      circuitHaveHighFrequencySignals_otherNotes : new FormControl('', [Validators.required, Validators.maxLength(250)]),
      indBoardXDim : new FormControl('', [Validators.required]),
      indBoardYDim : new FormControl('', [Validators.required]),
      boardOutlineGuidelineAvailable : new FormControl('', [Validators.required]),
      boardOutlineGuidelineAvailable_otherNotes : new FormControl('', [Validators.required, Validators.maxLength(250)]),
      constraintsOnICMountingHoles : new FormControl('', [Validators.required]),
      maxHeightOnTheTopAndBottomLayer : new FormControl('', [Validators.required]),
      docForDetailsOfTheBoard : new FormControl('', [Validators.required]),
      thicknessOfTheBoard : new FormControl('', [Validators.required]),
      thicknessOfTheBoard_otherNotes : new FormControl('', [Validators.required, Validators.maxLength(250)]),
      pcbTypeForDesign : new FormControl('', [Validators.required]),
      pcbTypeForDesign_otherNotes : new FormControl('', [Validators.required, Validators.maxLength(250)]),
      circuitBoardOperatingSpeed : new FormControl('', [Validators.required]),
      natureOfSignals : new FormControl('', [Validators.required]),
      pcbPartNumber : new FormControl('', [Validators.required, Validators.maxLength(100)]),
      layers: new FormControl('', [Validators.required]),
      customerNotes: new FormControl('', [Validators.required, Validators.maxLength(500)]),
      fileName:new FormControl('', [Validators.required]),
      recaptcha: new FormControl('', [Validators.required]),
    })

    this.activatedRoute.queryParams.subscribe(params => {
      if(Object.keys(params).length>0){
        if(params && params['data']){
          this.restAPI.encryptedData['encrypt'] = params['data']
        }else{
          // window.location.href = 'https://www.protoexpress.com/customer-portal/home.jsp';
          this.navigationUrl();
        }

        if(this.restAPI.encryptedData['encrypt']){
          localStorage.setItem('encUserData',this.restAPI.encryptedData['encrypt']);
        }
      }else{
        // window.location.href = 'https://www.protoexpress.com/customer-portal/home.jsp';
        this.navigationUrl();
      }
    });
}

  ngOnInit(): void {


    
    this.layersData = [];
    // this.layersData = [
    //   {"id":"2","name" : "1 Layer"},
    //   {"id":"3","name" : "2 Layer"},
    //   {"id":"4","name" : "3 Layer"},
    //   {"id":"5","name" : "4 Layer"},
    //   {"id":"6","name" : "5 Layer"},
    //   {"id":"7","name" : "6 Layer"},
    //   {"id":"8","name" : "7 Layer"},
    //   {"id":"9","name" : "8 Layer"},
    //   {"id":"10","name" : "9 Layer"},
    //   {"id":"11","name" : "10 Layer"},
    //   {"id":"12","name" : "11 Layer"},
    //   {"id":"13","name" : "12 Layer"},
    //   {"id":"14","name" : "13 Layer"},
    //   {"id":"15","name" : "14 Layer"},
    //   {"id":"16","name" : "15 Layer"},
    //   {"id":"17","name" : "16 Layer"},
    //   {"id":"18","name" : "17 Layer"},
    //   {"id":"19","name" : "18 Layer"},
    //   {"id":"20","name" : "19 Layer"},
    //   {"id":"21","name" : "20 Layer"},
    //   {"id":"22","name" : "21 Layer"},
    //   {"id":"23","name" : "22 Layer"},
    //   {"id":"24","name" : "23 Layer"},
    //   {"id":"25","name" : "24 Layer"},
    //   {"id":"26","name" : "25 Layer"},
    //   {"id":"27","name" : "26 Layer"},
    //   {"id":"28","name" : "27 Layer"},
    //   {"id":"29","name" : "28 Layer"},
    //   {"id":"30","name" : "29 Layer"},
    //   {"id":"31","name" : "30 Layer"},
    //   {"id":"32","name" : "31 Layer"},
    //   {"id":"33","name" : "32 Layer"}
    // ]

    for(var i=1;i<33;i++){
      this.layersData.push({"id": (i+1)+'',"name" : i+" Layer"})
    }
      // console.log(this.layersData)

    this.restAPI.getUserData(this.restAPI.encryptedData['encrypt']).subscribe((data: any) =>{
      if(data){
        this.restAPI.encryptedData.userData = data;
      }else{
        console.log(data)
        this.navigationUrl();
      }
    },(error: any)=>{
      console.log(error)
      if(error.status != 0 && error.status == 500){
        // window.location.href = 'https://www.protoexpress.com/customer-portal/home.jsp';
        this.navigationUrl();
      }else{
        Swal.fire('Oops!', 'Please try again', 'warning');
      }
    });

    setTimeout(()=>{window.scroll(0,0);},500);

    this.restAPI.generateAccessToken().subscribe((data)=>{
      this.new_accessToken = data.access_token;
    }, (error: any[])=>{
      console.log(error);
    });

    // this.generateAccessToken();
    this.expComMinDate = this.minDate;
  }


  saveQuote():any{
    var message = "";
    console.log(this.generalRep);
    this.checkAll = false;
    if ((!message) && (this.generalRep.expectedStartDate == null
      || this.generalRep.expectedStartDate==undefined
      || this.generalRep.expectedStartDate=="")){
        message = "Expected Start Date is required";
    }

    if ((!message) && (this.generalRep.designITAR == null
      || this.generalRep.designITAR==undefined
      || this.generalRep.designITAR=="")){
        message = "Design ITAR is required";
    }

    if ((!message) && (this.generalRep.expectedComplitionDate == null
      || this.generalRep.expectedComplitionDate==undefined
      || this.generalRep.expectedComplitionDate=="")){
        message = "Expected Complition Date is required";
    }

    if ((!message) && (this.generalRep.scopeOfDesign == null
      || this.generalRep.scopeOfDesign==undefined
      || this.generalRep.scopeOfDesign=="")){
        message = "Scope Of Design is required";
    }

    if ((!message) && (this.generalRep.isStatementOfWorkSOW == null
      || this.generalRep.isStatementOfWorkSOW==undefined
      || this.generalRep.isStatementOfWorkSOW=="")){
        message = "Is Statement Of Work SOW is required";
    }

    if ((!message) && (this.generalRep.billOfMaterialType == null
      || this.generalRep.billOfMaterialType==undefined
      || this.generalRep.billOfMaterialType=="")){
        message = "Is Bill Of Material Available is required";
    }

    if ((!message) && (this.generalRep.isTheSchematicAvailableForTheDesign == null
      || this.generalRep.isTheSchematicAvailableForTheDesign==undefined
      || this.generalRep.isTheSchematicAvailableForTheDesign=="")){
        message = "Is The Schematic Available For The Design is required";
    }

    if ((!message) && (this.generalRep.formatOfTheSchematicDesign == null
      || this.generalRep.formatOfTheSchematicDesign==undefined
      || this.generalRep.formatOfTheSchematicDesign=="")){
        message = "Format Of The Schematic Design is required";
    }

    if ((!message) && (this.generalRep.isABlockDiagramOfTheDesignAvailable == null
      || this.generalRep.isABlockDiagramOfTheDesignAvailable==undefined
      || this.generalRep.isABlockDiagramOfTheDesignAvailable=="")){
        message = "Is A Block Diagram Of The Design Available is required";
    }

    if ((!message) && (this.generalRep.developSchematicFromBlockDiagram == null
      || this.generalRep.developSchematicFromBlockDiagram==undefined
      || this.generalRep.developSchematicFromBlockDiagram=="")){
        message = "Develop Schematic From Block Diagram is required";
    }

    if ((!message) && (this.generalRep.describeYourBoard == null
      || this.generalRep.describeYourBoard==undefined
      || this.generalRep.describeYourBoard=="")){
        message = "Describe Your Board is required";
    }

    if ((!message) && (this.generalRep.indBoardXDim == null
      || this.generalRep.indBoardXDim==undefined
      || this.generalRep.indBoardXDim=="")){
        message = "Size of X required";
    }

    if ((!message) && (this.generalRep.indBoardYDim == null
      || this.generalRep.indBoardYDim==undefined
      || this.generalRep.indBoardYDim=="")){
        message = "Size of Y required";
    }

    if ((!message) && (this.generalRep.circuitHaveHighFrequencySignals == null
      || this.generalRep.circuitHaveHighFrequencySignals==undefined
      || this.generalRep.circuitHaveHighFrequencySignals=="")){
        message = "Circuit Have High Frequency Signals is required";
    }

    if ((!message) && (this.generalRep.boardOutlineGuidelineAvailable == null
      || this.generalRep.boardOutlineGuidelineAvailable==undefined
      || this.generalRep.boardOutlineGuidelineAvailable=="")){
        message = "Board Outline Guide line Available is required";
    }

    if ((!message) && (this.generalRep.constraintsOnICMountingHoles == null
      || this.generalRep.constraintsOnICMountingHoles==undefined
      || this.generalRep.constraintsOnICMountingHoles=="")){
        message = "Constraints On IC Mounting Holes is required";
    }

    if ((!message) && (this.generalRep.maxHeightOnTheTopAndBottomLayer == null
      || this.generalRep.maxHeightOnTheTopAndBottomLayer==undefined
      || this.generalRep.maxHeightOnTheTopAndBottomLayer=="")){
        message = "Max Height On The Top And Bottom Layer is required";
    }

    if ((!message) && (this.generalRep.docForDetailsOfTheBoard == null
      || this.generalRep.docForDetailsOfTheBoard==undefined
      || this.generalRep.docForDetailsOfTheBoard=="")){
        message = "Doc For Details Of The Board is required";
    }

    if ((!message) && (this.generalRep.thicknessOfTheBoard == null
      || this.generalRep.thicknessOfTheBoard==undefined
      || this.generalRep.thicknessOfTheBoard==""
      || this.generalRep.thicknessOfTheBoard=="select")){
        message = "Thickness Of The Board is required";
    }

    if ((!message) && (this.generalRep.pcbTypeForDesign == null
      || this.generalRep.pcbTypeForDesign==undefined
      || this.generalRep.pcbTypeForDesign=="")){
        message = "PCB Type For Design is required";
    }

    if ((!message) && (this.generalRep.circuitBoardOperatingSpeed == null
      || this.generalRep.circuitBoardOperatingSpeed==undefined
      || this.generalRep.circuitBoardOperatingSpeed=="")){
        message = "Circuit Board Operating Speed is required";
    }

    if ((!message) && (this.generalRep.natureOfSignals == null
      || this.generalRep.natureOfSignals==undefined
      || this.generalRep.natureOfSignals=="")){
        message = "Nature Of Signals is required";
    }

    if ((!message) && (this.generalRep.pcbPartNumber == null
      || this.generalRep.pcbPartNumber==undefined
      || this.generalRep.pcbPartNumber=="")){
        message = "PCB Part Number is required";
    }

    if ((!message) && (this.generalRep.layers == null
      || this.generalRep.layers==undefined
      || this.generalRep.layers=="")){
        message = "Layer is required";
    }

    if (this.generalRep.scopeOfDesign == '5' && !this.generalRep.scopeOfDesign_otherNotes) {
      message = "Scope Of Design Other Notes is required";
    }

    if (this.generalRep.describeYourBoard == '5' && !this.generalRep.describeYourBoard_otherNotes) {
      message = "Describe Your Board Notes is required";
    }

    if (this.generalRep.circuitHaveHighFrequencySignals == '3' && !this.generalRep.circuitHaveHighFrequencySignals_otherNotes) {
      message = "Circuit Have High Frequency Signals Notes is required";
    }

    if (this.generalRep.boardOutlineGuidelineAvailable == '3' && !this.generalRep.boardOutlineGuidelineAvailable_otherNotes) {
      message = "Board Outline Guide line Available Notes is required";
    }

    if (this.generalRep.thicknessOfTheBoard == '8' && !this.generalRep.thicknessOfTheBoard_otherNotes) {
      message = "Thickness Of The Board Notes is required";
    }

    if (this.generalRep.layers == 'YES' && !this.customData.selectedLayer) {
      message = "Select Layer from the list";
    }

    if (this.generalRep.billOfMaterialType == 'YES' && !this.customData.selectedBomLayer) {
      message = "Choose one option from the Bill Of Material Available list";
    }

    if ((!message) && (this.generalRep.recaptcha == null
      || this.generalRep.recaptcha==undefined
      || this.generalRep.recaptcha=="")){
        message = "Captcha is required";
    }

    if (message){
      this.checkAll = true;
      //Swal.fire('', message, 'warning');
      setTimeout(()=>{window.scroll(0,0);},500);
      return false;
    }

    this.generalRep.layers = this.generalRep.layers == 'YES' ? this.customData.selectedLayer: '0';
    // this.generalRep.layers = this.generalRep.layers == 'YES' ? this.customData.selectedLayer: null;
    this.generalRep.billOfMaterialType = this.generalRep.billOfMaterialType == 'YES' ? this.customData.selectedBomLayer: '0';
    if (this.generalRep.expectedStartDate) {
      //this.generalRep.expectedStartDate = this.generalRep.expectedStartDate.month +'/'+this.generalRep.expectedStartDate.day+'/'+this.generalRep.expectedStartDate.year;
      const d = new Date(this.generalRep.expectedStartDate.year+'/'+this.generalRep.expectedStartDate.month+'/'+this.generalRep.expectedStartDate.day);
      this.generalRep.expectedStartDate = moment(d).format("MMM DD YYYY");
      console.log(this.generalRep.expectedStartDate);
    }
    if (this.generalRep.expectedComplitionDate) {
      //this.generalRep.expectedComplitionDate = this.generalRep.expectedComplitionDate.month +'/'+this.generalRep.expectedComplitionDate.day+'/'+this.generalRep.expectedComplitionDate.year;
      const d = new Date(this.generalRep.expectedComplitionDate.year+'/'+this.generalRep.expectedComplitionDate.month+'/'+this.generalRep.expectedComplitionDate.day);
      this.generalRep.expectedComplitionDate = moment(d).format("MMM DD YYYY");
      console.log(this.generalRep.expectedComplitionDate);
    }
    delete this.generalRep.recaptcha;
    // delete this.generalRep.layers;
    console.log("formData", this.generalRep);
    this.spinner.show();
    this.restAPI.formSubmit(this.generalRep,this.filesList,this.new_accessToken).subscribe((data:any)=>{
      this.spinner.hide();
      if(data.requestNumber){
        Swal.fire({
          title: 'Congratulations',
          text: 'Your Design related details has been submitted successfully. You will get a confirmation email soon.',
          icon: 'success',
          showCloseButton: true,
          confirmButtonText: 'Ok',
          allowOutsideClick: false
        }).then(() => {
          // let url;
          // if(){
          //   url = sessionStorage.getItem('redirectUrl')
          //   // window.open(url+'',"_blank")
          // }else{
          //   url = this.restApi.logoUrl
          // }
          // window.location.href = url+'';

          // location.reload();
          //window.location.href = 'https://www.protoexpress.com/customer-portal/home.jsp';
          if (location.host.indexOf('staging')>=0 || location.host.indexOf('local')>=0) {
            window.location.href = 'https://staging.protoexpress.com/customer-portal/home.jsp';
          }else{
            window.location.href = 'https://www.protoexpress.com/customer-portal/home.jsp';
          }
          //this.navigationUrl();
        })
        
      }
    },(error)=>{
      this.spinner.hide();
      console.log(error);
    });
  }

  onSelected(val: any){
    this.customData.selectedLayer = val;
  }

  onBomSelected(val: any){
    this.customData.selectedBomLayer = val;
  }

  exStartDateChange(expDate:any){
    this.generalRep.expectedComplitionDate = '';
      setTimeout(() => {
        var selectedStartDate = (this.generalRep.expectedStartDate.year+"/"+this.generalRep.expectedStartDate.month+"/"+this.generalRep.expectedStartDate.day)+'';
        const current = new Date(selectedStartDate);
        const last = new Date(current.getTime() + (1 * 24 * 60 * 60 * 1000));
        // this.config.minDate = { year: last.getFullYear(), month: 
        // last.getMonth() + 1, day: last.getDate() };
        
        this.expComMinDate = { year: last.getFullYear(), month: 
        last.getMonth() + 1, day: last.getDate() };
      }, 500)
  }
  exEndDateChange(expEndDate:any){
    console.log(expEndDate);
    if(this.generalRep.expectedStartDate == ''){
      this.expComMinDate = this.minDate;
    }
  }

  fileBrowseHandler(logs: any){
    console.log(logs.files);
    for(var k = 0; k<logs.files.length; k++){
      this.filesList.push({'name': logs.files[k].name,'id': this.filesList.length+1,'file': logs.files[k]})
    }
    this.generalForm.controls['fileName'].reset({ value: this.filesList[0].name, disabled: true });
    // this.customData.selectedFile = logs.files[0];
    console.log(this.filesList);
    // document.getElementById("fileUpload").setAttribute("value", '');

    // let fileList = (<HTMLInputElement>logs).files;
    // if (fileList && fileList.length > 0) {
    //       let file: File = fileList[0];
    //       console.log(file.name);
    //       console.log(file.size);
    //       console.log(file.type);
    
    //       let reader: FileReader = new FileReader();
    //       reader.readAsText(file);
    //       reader.onload = e => {
    //         let csv: any = reader.result;
    //         let allTextLines = [];
    //         allTextLines = csv.split(/\r|\n|\r/);
    
    //         let headers = allTextLines[0].split(";");
    //         let data = headers;
    //         let tarr = [];
    //         for (let j = 0; j < headers.length; j++) {
    //           tarr.push(data[j]);
    //         }
    //         this.lines.push(tarr);
    //         let tarrR = [];
    //         let arrl = allTextLines.length;
    //         let rows = [];
    //         for (let i = 1; i < arrl; i++) {
    //           rows.push(allTextLines[i].split(";"));
    //         }
    //         for (let j = 0; j < arrl; j++) {
    //           tarrR.push(rows[j]);
    //         }
    //         this.linesR.push(tarrR);
    //       };
    //   }
  }

  removeFileList(indx: any){
    this.generalForm.controls['fileName'].reset({ value: '', disabled: false });
    this.filesList.splice(parseInt(indx),1);
  }

  downloadFile(indx: any, element: any){
    let objectURL;

    const file = this.filesList[indx].file;
    objectURL = URL.createObjectURL(file);

    element.download = this.filesList[indx].name; 
    element.href = objectURL;
  }

  onInputCheck(event: any,fieldName:any, ml: any): boolean{
    if (ml && event.target.textLength>=ml) {
      event.target.value = event.target.value.substring(0, parseInt(ml));
      this.generalForm.controls[fieldName].setValue(event.target.value,{emitEvent:false});
      this.generalForm.controls[fieldName].updateValueAndValidity();
      event.preventDefault();
      return false;
    }

    return true
  }

  navigationUrl(){
    if (location.host.indexOf('staging')>=0 || location.host.indexOf('local')>=0) {
      //window.location.href = 'https://staging.protoexpress.com/design-request-for-quote/';
    }else{
      //window.location.href = 'https://www.protoexpress.com/design-request-for-quote/';
    }
  }
}
